<template>
  <Teleport
    to="#alerts"
    v-if="isFlashMessage">
    <div
      class="clipboard-alert"
      key="alert">
      <p class="h1 clipboard-content">
        {{ notification.message }}
      </p>
    </div>
  </Teleport>

  <Modal
    v-else
    v-model="show"
    :header="false"
    :footer="false"
    @hide="remove(notification)">
    <div class="text-lg leading-tight">
      <h1 class="mb-7 flex items-center text-2xl">
        <ExclamationCircleIcon class="mr-2 h-8 w-8 text-red-700" />
        Something has gone wrong
      </h1>
      <p>
        {{
          notification.message ||
          'Our apologies, an error occurred while processing your command. Please check your connection and try again.'
        }}
      </p>
      <ButtonPrimary
        type="button"
        @click="show = false"
        class="mt-7 w-full uppercase">
        Close
      </ButtonPrimary>
    </div>
  </Modal>
</template>

<script>
import { mapActions } from 'vuex';
import { Modal } from 'uiv';
import { ExclamationCircleIcon } from '@heroicons/vue/24/outline';
import ButtonPrimary from '@/components/buttons/ButtonPrimary.vue';

export default {
  components: {
    ButtonPrimary,
    Modal,
    ExclamationCircleIcon,
  },
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      timeout: null,
      show: true,
    };
  },
  computed: {
    isFlashMessage() {
      return this.notification.type === 'success' || this.notification.type === 'flash';
    },
  },
  mounted() {
    const TIMEOUT_MS = this.isFlashMessage ? 2000 : 5000;
    this.timeout = setTimeout(() => {
      this.show = false;
      if (this.isFlashMessage) {
        this.remove(this.notification);
      }
    }, TIMEOUT_MS);
  },
  beforeUnmount() {
    clearTimeout(this.timeout);
  },
  methods: {
    ...mapActions('notifications', ['remove']),
  },
};
</script>
